'use strict';

const sanitizer = require('./sanitizer');

module.exports = sanitizer;
